import {Brick, registerBrick, Transaction, Query, Predicate} from 'olympe';
import {PurchaseRequest} from '../../models/PurchaseRequest';
import {createPRJson} from '../createPRJson';
import PurchaseRequestDM from '../../models/cloudobjects/PurchaseRequestDM';
import {findUnassignedPRsLambda} from '../functionSignatures';

/**
 * This brick checks if there are some PR unassigned and assign them to the correct user
 */
export default class CheckForPRCreatedBeforeUserJoined extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} userID
     * @param {string} email
     * @param {string} fullName
     * @param {*} findUnassignedPRs
     * @param {function()} forwardEvent
     */
    async update($, [userID, email, fullName, findUnassignedPRs], [forwardEvent]) {
        /**
         * Update the PR with the correct full name, email, and user id
         * @param {PurchaseRequest} pr
         * @return {PurchaseRequest}
         */
        const updatePr = (pr) => {
            if (pr.spender.value?.toUpperCase() === userID.toUpperCase()) { // If the PR has been created with an unknown user ID (for spender)
                pr.spender.email = email;
                pr.spender.label = fullName;
            } else if (pr.spender.email?.toUpperCase() === email.toUpperCase()) { // If the PR has been created with an unknown email (for spender)
                pr.spender.value = userID;
                pr.spender.label = fullName;
            }

            if (pr.requester.value?.toUpperCase() === userID.toUpperCase()) { // If the PR has been created with an unknown user ID (for requester)
                pr.requester.email = email;
                pr.requester.label = fullName;
            } else if (pr.requester.email?.toUpperCase() === email.toUpperCase()) { // If the PR has been created with an unknown email (for requester)
                pr.requester.value = userID;
                pr.requester.label = fullName;
            }

            return pr;
        };

        findUnassignedPRsLambda($, findUnassignedPRs, email, userID)
            .then(async (result) => {
                const filteredPRs = JSON.parse(result[0]);

                if (filteredPRs.length > 0) {
                    const PRs = await Query.instancesOf(PurchaseRequestDM).filter(Predicate.in(...(filteredPRs.map((pr) => pr['tagOlympe'])))).execute();
                    const t = new Transaction(true);

                    for (const pr of PRs.toArray()) {
                        const updatedPr = updatePr(new PurchaseRequest(pr.getJson()));
                        PurchaseRequestDM.updatePurchaseRequestFromJson(createPRJson(updatedPr), pr.tag, t);
                    }

                    t.execute()
                        .then(forwardEvent())
                        .catch((reason) => {
                            console.error(reason);
                            forwardEvent();
                        });
                } else {
                    forwardEvent();
                }
            })
            .catch((reason) => {
                console.error(reason);
                forwardEvent();
            });
    }
}

registerBrick('018dac5ca9deba4eda64', CheckForPRCreatedBeforeUserJoined);
